import { render, staticRenderFns } from "./formOrder.vue?vue&type=template&id=5da8bc57&"
import script from "./formOrder.vue?vue&type=script&lang=js&"
export * from "./formOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports